import { IBeneficiaries } from "@interfaces/screens/beneficiaries.interface";
import { BasePresenter } from "@presenters/base/base.presenter";
import { dxDataGridColumn } from 'devextreme/ui/data_grid';
import { ILang, IBudgetFormBasicDataMasters } from '@models/*';
import { useSelector } from 'react-redux';
import { IDataGridOptions } from "devextreme-react/data-grid";
import { Enums, Dictionary, Utilities } from "@utils";

export class BeneficiariesPresenter extends BasePresenter<IBeneficiaries> {
  public currentLang: ILang;
  public BudgetsData: any;
  public currentLabels: Dictionary<string, string>;
  public formMasters: IBudgetFormBasicDataMasters;
  public params: any;

  constructor(view: IBeneficiaries) {
    super(view);
    this.currentLang = useSelector(this.context.sessionStore.selectLang);
    this.BudgetsData = useSelector(this.context.proaStore.selectBudgetsData);
    this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    this.params = useSelector(this.context.sessionStore.selectParams);
    this.formMasters = useSelector(this.context.proaStore.selectFormMasters);
  }

  public async initialize() {
    this.dispatcher(this.context.proaStore.getProaBudget());
    this.dispatcher(this.context.proaStore.getAllFormMasters());
  }

  public initReport() {
    this.view.state.setDataColumns(this.getReportColumns());
    this.view.state.setDataSource(this.getDataSource());
  }

  public getDataSource(): any {
    let countries: string[] = [];
    let dataSource: any[] = [];
    const budgetsData: any = Utilities.copyObject(this.BudgetsData) as any;

    if(budgetsData){
      budgetsData.forEach((data: any)=> {
        data.PPresuAnio = data?.PPresAnio?.Title;
        data.PaisRegion = data.OCTAVIAPaisId ? data?.OCTAVIAPais?.Title : data?.OCTAVIARegion?.Title;
        switch (this.currentLang.label) {
          case "EN":
           data.PaisRegion = data.OCTAVIAPaisId ? data?.OCTAVIAPais?.OCTAVIANombreEn : data?.OCTAVIARegion?.OCTAVIANombreEn;
            break;
          case "PT":
            data.PaisRegion = data.OCTAVIAPaisId ? data?.OCTAVIAPais?.OCTAVIANombrePT : data?.OCTAVIARegion?.OCTAVIANombrePT;
            break;
          case "FR":
            data.PaisRegion = data.OCTAVIAPaisId ? data?.OCTAVIAPais?.OCTAVIANombreFR : data?.OCTAVIARegion?.OCTAVIANombreFR;
            break;
        }
        if(!countries.includes(`${data.PaisRegion}${data.PPresuAnio}`)){
          countries.push(`${data.PaisRegion}${data.PPresuAnio}`)
          data.canEdit = this.getTotalPermissions(data.PaisRegion)
          dataSource.push(data)
        }
      })
      dataSource = dataSource.sort((a: any, b: any) => {
        if (parseInt(a.PPresuAnio) > parseInt(b.PPresuAnio)) return 1;
        if (parseInt(a.PPresuAnio) < parseInt(b.PPresuAnio)) return -1;
        if (parseInt(a.PPresuAnio) == parseInt(b.PPresuAnio)){
          if (a.PaisRegion > b.PaisRegion) return 1;
          else if (a.PaisRegion < b.PaisRegion) return -1;
          return 0;
        }
      })
    }
    return dataSource;
  }

  private getReportColumns() {
   
    return <dxDataGridColumn[]>[
      {
        caption: this.currentLabels.get("Anio"),
        dataField: 'PPresuAnio',
        visible: true,
        dataType: 'number',
        alignment: 'center',
        minWidth: 100
      },
      {
        caption: this.currentLabels.get("PaisRegion"),
        dataField: 'PaisRegion',
        visible: true,
        dataType: 'string',
        alignment: 'center',
        minWidth: 100
      },
      {
        caption: this.currentLabels.get("Acciones"),
        dataField: "botones",
        alignment: "center",
        type: "buttons",
        minWidth: 100,
        buttons: [
          {
            hint: "Ver",
            icon: "bulletlist",
            visible: true,
            onClick: (e) => {
              this.context.history.push(
                `/proyecta/proa/beneficiaries/view?Year=${e.row.data.PPresuAnio}&Country=${e.row.data.PaisRegion}`
              );
            },
          },
          {
            hint: "Editar",
            icon: "edit",
            visible: (e) => e.row.data.canEdit,
            onClick: (e) => {
              this.context.history.push(
                `/proyecta/proa/beneficiaries/edit?Year=${e.row.data.PPresuAnio}&Country=${e.row.data.PaisRegion}`
              );
            },
          },
        ],
      }
    ];
  }

  public getTotalPermissions(country: string){
    const TEAM_CENTRAL = this.params[Enums.Params.proyectaCentralTeam]
    const ADMIN_GROUP = this.params[Enums.Params.proyectaAdminModule]

    let countryRegionGroup: string = [...this.formMasters?.countries, ...this.formMasters?.regions]?.find((cr: any) => cr.Title === country)?.SGGrupoAD
    let userGroupsId: any[] = this?.currentUser?.userGroups?.map((x: any) => x.id)
    let userGroupsName: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)

    return (userGroupsName?.includes(TEAM_CENTRAL) || userGroupsName?.includes(ADMIN_GROUP) || userGroupsId?.includes(countryRegionGroup))
  }

  public options: IDataGridOptions = {
    columns: this.view.state.dataColumns,
    dataSource: this.view.state.dataSource,
    filterPanel: { visible: true },
    filterRow: { visible: true },   
    allowColumnResizing: true, 
    export: {
      enabled: false,
      excelFilterEnabled: false,
      excelWrapTextEnabled: true
    },
      onToolbarPreparing: null,
  };
   
}
